import React from 'react';
import { motion } from 'framer-motion';
import { IMAGE_ASSETS } from '../constants/images';
import { useLanguage } from '../context/LanguageContext';

export default function Gallery() {
  const { t } = useLanguage();

  return (
    <div className="container mx-auto px-4 py-16">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
        <h1 className="text-5xl font-bold text-brand-navy mb-4">{t('nav.gallery')}</h1>
        <div className="h-1 w-24 bg-brand-gold mx-auto rounded mb-6"></div>
      </motion.div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {IMAGE_ASSETS.gallery.map((src, idx) => (
          <motion.div key={idx} initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: idx * 0.1 }} className="overflow-hidden rounded-xl shadow-md group aspect-[4/3]">
            <img src={src} alt={`Gallery image ${idx + 1}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
          </motion.div>
        ))}
      </div>
    </div>
  );
}